module.exports = __webpack_public_path__ + "static/media/javeria.6d2d2b4f.jpg";